var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-3",attrs:{"icon":""},on:{"click":function($event){return _vm.onBtnClick()}}},[_c('v-img',{attrs:{"max-height":"40","max-width":"40","src":require(("@/assets/" + _vm.filename))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }